import i18next from 'i18next';

export default function initI18n(): void {
  i18next.addResourceBundle('en', 'tool-set-ui', {
    addToolSet: 'Add Tool Set',
    toolSetsTitle: 'Tool Sets',
    editToolSet: 'Edit tool set',
    toolCatalogLoadError:
      'Could not load the tool catalog. Refresh the page or check that you are signed in as an admin.',
    availableSourcesCount: 'Available sources ({{count}})',
    clickItemToAddHint: 'Click an item to add it to this tool set.',
    noSourcesAvailable: 'No native tool groups or MCP servers are available for this app.',
    configuredSourcesCount: 'Configured sources ({{count}})',
    refreshTools: 'Refresh tools',
    initiallyLoadedCount: 'Initially loaded: {{count}}',
    removeSource: 'Remove source',
    deferAllTools: 'Defer all tools',
    noToolsInCache: 'No tools in cache yet. Discover tools on Forgentic, then refresh here.',
    openInEditor: 'Open in editor',
    trashToolSet: 'Trash tool set',
    deleteToolSet: 'Delete tool set',
    toolSetCreated: 'New tool set created',
    trashToolSetConfirmDescription: 'Are you sure you want to send "{{name}}" to the trash?',
    toolSetTrashed: 'Tool set moved to the trash',
    toolSetRestoreFailed: 'Could not restore the tool set',
    deleteToolSetConfirmDescription: 'Permanently delete "{{name}}"? This cannot be undone.',
    toolSetDeleted: 'Tool set deleted',
    cancel: 'Cancel',
  });
}
